export const REQUEST_LOOKUP_CREATE = 'lookup/REQUEST_LOOKUP_CREATE';

export const RECEIVED_LOOKUP_CREATE = 'lookup/RECEIVED_LOOKUP_CREATE';

export const REQUEST_LOOKUP_UPDATE = 'lookup/REQUEST_LOOKUP_UPDATE';
export const RECEIVED_LOOKUP_UPDATE = 'lookup/REQUEST_LOOKUP_TYPE';



export const RECEIVED_GET_ALL_LOOKUP_TYPE = 'lookup/RECEIVED_GET_ALL_LOOKUP_TYPE';

export const RECEIVED_GET_ALL_LOOKUP_DATA = 'lookup/C';


export const REQUEST_SYSTEM_LOOKUP_CREATE = 'lookup/REQUEST_SYSTEM_LOOKUP_CREATE';
export const REQUEST_SYSTEM_LOOKUP_DELETE = 'lookup/REQUEST_SYSTEM_LOOKUP_DELETE';
export const REQUEST_SYSTEM_LOOKUP_UPDATE = 'lookup/REQUEST_SYSTEM_LOOKUP_UPDATE';

export const REQUEST_CLIENT_LOOKUP_CREATE = 'lookup/REQUEST_CLIENT_LOOKUP_CREATE';
export const REQUEST_CLIENT_LOOKUP_DELETE = 'lookup/REQUEST_CLIENT_LOOKUP_DELETE';
export const REQUEST_CLIENT_LOOKUP_UPDATE = 'lookup/REQUEST_CLIENT_LOOKUP_UPDATE';

export const RECEIVED_ALL_LOOKUP_DATA = "lookup/RECEIVED_ALL_LOOKUP_DATA";
